import { useState } from "react";

type Callback = (data: any) => void;

export interface PubSub {
  events: { [key: string]: Callback[] };
  subscribe: (event: string, callback: Callback) => void;
  publish: (event: string, data: any) => void;
  unsubscribe: (event: string, callback: Callback) => void;
}

const usePubSub = (): PubSub => {
  const [events, setEvents] = useState<{ [key: string]: Callback[] }>({});

  const subscribe = (event: string, callback: Callback) => {
    setEvents((prevEvents) => ({
      ...prevEvents,
      [event]: [...(prevEvents[event] || []), callback],
    }));
  };

  const unsubscribe = (event: string, callback: Callback) => {
    setEvents((prevEvents) => ({
      ...prevEvents,
      [event]: (prevEvents[event] || []).filter((cb) => cb !== callback),
    }));
  };

  const publish = (event: string, data: any) => {
    if (events[event]) {
      events[event].forEach((callback) => callback(data));
    }
  };

  return { events, subscribe, publish, unsubscribe };
};
export default usePubSub;
